import {defineStore} from 'pinia'
import axios from "axios";
import {loginUrl, logoutUrl, userDetailsUrl} from "@/services/api";
import {IUser} from "@/types/user";

// You can name the return value of `defineStore()` anything you want,
// but it's best to use the name of the store and surround it with `use`
// and `Store` (e.g. `useUserStore`, `useCartStore`, `useProductStore`)
// the first argument is a unique id of the store across your application
export const useAuthStore = defineStore('auth', {
    state: () => ({
        loading: false as boolean,
        user: undefined as IUser | undefined,
    }),
    persist: true,
    getters: {
        isAuthenticated: (state) => state.user !== undefined,
        getToken: (state) => state.user?.token ?? '',
        isAuthenticationLoading: (state): boolean => state.loading,
    },
    actions: {
        async login(username: string, password: string) {
            this.loading = true;
            const responseAuth = await axios.post(loginUrl, {
                username: username,
                password: password,
            });
            if (responseAuth.status == 200) {
                const responseUser = await axios.get(userDetailsUrl, {
                    headers: {
                        "Authorization": `Token ${responseAuth.data.token}`
                    }
                });
                this.user = {
                    ...responseUser.data,
                    token: responseAuth.data.token
                };
            }
            this.loading = false;
            return responseAuth
        },
        async logout() {
            const response = await axios.get(logoutUrl);
            this.user = undefined;
        }
    }
});
/*

const setToken = (token: string) => {
    axios.defaults.headers.common['Authorization'] = `Token ${token}`;
};

const unsetToken = (token: string) => {
    axios.defaults.headers.common['Authorization'] = '';
};
*/
